export const MESSAGES = {
    POWERED_BY: "Inspired by Ayurveda, enabled by AI. DaburGPT may make mistakes — please verify.",
  };